<!--
  @Author: ljl
  @Desc: 线上合同签署
  @Date: 2024-03-12
  @tip: 
  页面使用 pageIndex 接收 1 为经办人验证 2 为企业
  operatorVerifyStatus 经办人验证状态 1 已验证 其他未
  paymentVerifyStatus 支付验证状态 1 已验证 -1 失败 0 未验证 3 验证中
-->

<template>
  <div class="page" ref="page">
    <div class="page-title">
      <div class="image-logo" v-if="oemShow">
        <img src="../../../static/onLineContractSign/img_logo.png" alt="" />
      </div>
      <div class="image-bg" v-if="oemShow">
        <img src="../../../static/onLineContractSign/img_bg.png" alt="" />
      </div>
    </div>

    <div class="information">
      <div class="content">
        <!-- 进度 -->
        <div class="schedule">
          <div class="one">
            <div :class="['ball', pageIndex == 1 ? 'blueBall' : 'whiteBall']">
              <span>1</span>
            </div>
            <div class="character">
              经办人实名认证
            </div>
          </div>
          <div class="line"></div>
          <div class="one">
            <div :class="['ball', pageIndex == 2 ? 'blueBall' : 'whiteBall']">
              <span>2</span>
            </div>
            <div class="character">
              企业实名认证
            </div>
          </div>
          <div class="line margin16"></div>
          <div class="one">
            <div class="ball whiteBall">
              <span>3</span>
            </div>
            <div class="character">
              签署合同
            </div>
          </div>
        </div>

        <!-- 提示 -->
        <div :class="['tips', pageIndex == 1 ? 'tipsOne' : 'tipsTow']">
          <div class="icon-tips">
            <img
              src="../../../static/onLineContractSign/icon_check.png"
              alt=""
            />
          </div>
          <div v-if="pageIndex == 1" class="text">核验经办人的实名手机号</div>
          <div v-if="pageIndex == 2" class="text-box">
            企业对公账户将收到0.10元以下随机金额的打款，请回填打款金额和收款交易明细中的验证码。
            <span class="btnNoBorderTrBlue btn" @click="showViewer = true"
              >查看示例</span
            >
          </div>
        </div>

        <!-- 表单 个人 -->
        <el-form
          v-if="pageIndex == 1"
          :model="thatPersonForm"
          :rules="rules"
          :label-width="forms.labelWidth121"
          ref="thatPersonFormRef"
          id="onlineContractSign"
        >
          <el-form-item label="姓名：" prop="operatorName">
            <el-input
              v-model="thatPersonForm.operatorName"
              placeholder="请填写姓名"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号：" prop="operatorIdCard">
            <el-input
              v-model="thatPersonForm.operatorIdCard"
              placeholder="请填写身份证号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="operatorMobile">
            <el-input
              v-model="thatPersonForm.operatorMobile"
              placeholder="请填写实名手机号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="operatorEmail">
            <el-input
              v-model="thatPersonForm.operatorEmail"
              placeholder="请填写电子邮箱"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="通讯地址：" prop="operatorAddress">
            <el-input
              v-model="thatPersonForm.operatorAddress"
              placeholder="请填写通讯地址"
              clearable
              maxlength="128"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <span
              class="btnLargeFullColor"
              @click="submitUpload('thatPersonFormRef')"
              >下一步</span
            >
          </el-form-item>
        </el-form>

        <!-- 表单 企业 -->
        <el-form
          v-if="pageIndex == 2"
          :model="enterpriseForm"
          :rules="rules"
          :label-width="forms.labelWidth121"
          ref="enterpriseFormRef"
          id="onlineContractSign"
        >
          <el-form-item label="银行户名：" prop="cooperatorName">
            <span class="greyColor">{{ enterpriseForm.cooperatorName }}</span>
          </el-form-item>
          <el-form-item label="银行账号：" prop="paymentBankAccountNo">
            <el-input
              :disabled="!disabled"
              v-model="enterpriseForm.paymentBankAccountNo"
              placeholder="请填写企业银行账号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行：" prop="paymentBankBranchName">
            <el-input
              :disabled="!disabled"
              v-model="enterpriseForm.paymentBankBranchName"
              placeholder="请正确填写开户行银行支行信息"
              clearable
            ></el-input>
          </el-form-item>
          <div class="form_money">
            <el-form-item label="金额：" prop="amount">
              <el-input
                :disabled="disabled"
                v-model="enterpriseForm.amount"
                placeholder="请填写对公账户收到的金额（<0.1元）"
                clearable
              ></el-input>
            </el-form-item>
            <span
              v-if="!!disabled"
              class="btnNoBorderTrBlue moneyBtn"
              @click="xhrPayment"
              >申请对公打款</span
            >
            <span v-if="!disabled" class="moneyBtn sureBtn"
              >已打款（3日内有效）</span
            >
          </div>
          <el-form-item label="验证码：" prop="smsCode">
            <el-input
              :disabled="disabled"
              v-model="enterpriseForm.smsCode"
              placeholder="请填写对公账户收款交易明细中的验证码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <span
              v-if="!disabled"
              class="btnLargeFullColor"
              @click="xhrModifyBankInfo"
              >修改银行信息</span
            >
            <span
              :class="[
                !!disabled ? 'btnLineColorDisabled' : 'btnLargeFullColor'
              ]"
              @click="submitUpload('enterpriseFormRef')"
              >下一步</span
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="() => (showViewer = false)"
      :url-list="['../../../static/onLineContractSign/photo.jpg']"
    ></el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { Rules } from "./vdt/form_validata.js";
import { FORMS } from "../../service/businessConsts.js";
import { HTTP_CODE } from "../../../build/axios_constants";
import { setLocal } from "../../filters/filters.js";
export default {
  components: { ElImageViewer },
  data() {
    return {
      forms: FORMS,
      rules: Rules,
      pageIndex: 1,
      disabled: true,
      showViewer: false,
      thatPersonForm: {
        operatorName: "",
        operatorIdCard: "",
        operatorMobile: "",
        operatorEmail: "",
        operatorAddress: ""
      },
      enterpriseForm: {
        cooperatorName: "",
        paymentBankAccountNo: "",
        paymentBankBranchName: "",
        amount: "",
        smsCode: ""
      }
    };
  },

  watch: {
    disabled: {
      handler(newValue, oldValue) {
        this.rules.amount[0].required = !newValue;
        this.rules.smsCode[0].required = !newValue;
      },
      deep: true,
      immediate: true,
      oemShow: false
    }
  },

  created() {
    this.oemShow =
      window.location.hostname !== "web.hvyogo.com" ||
      window.location.hostname !== "bweb.hvyogo.com";
    // 过期状态可再次申请验证
    this.whitenessCooperatorData();
  },

  methods: {
    // xhr - 查询商户合同信息
    whitenessCooperatorData() {
      this.$http.getQueryOnlineContractInformation().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.pageIndex = res.data.operatorVerifyStatus == 1 ? 2 : 1;
          this.enterpriseForm.cooperatorName = res.data.cooperatorName; // 企业名称
          this.enterpriseForm.paymentBankAccountNo =
            res.data.paymentBankAccountNo;
          this.enterpriseForm.paymentBankBranchName =
            res.data.paymentBankBranchName;

          if (res.data.paymentVerifyStatus == 3) {
            // 信息已验证 开启支付验证
            this.disabled = false;
          } else {
            this.disabled = true;
          }
        }
      });
    },
    // 申请对公打款
    xhrPayment() {
      let validateFieldList = [];
      this.$refs.enterpriseFormRef.validateField(
        ["paymentBankAccountNo", "paymentBankBranchName"],
        async valid => {
          if (!valid) {
            validateFieldList.push(valid);
            if (validateFieldList.length == 2) {
              let params = {
                paymentBankAccountNo: this.enterpriseForm.paymentBankAccountNo,
                paymentBankBranchName: this.enterpriseForm.paymentBankBranchName
              };
              this.$http.postUpdatePaymentInformation(params).then(res => {
                if (res.statusCode === HTTP_CODE.suc) {
                  this.disabled = false; // 开启验证码输入框验证
                }
              });
            }
          }
        }
      );
    },

    // 修改银行信息
    xhrModifyBankInfo() {
      this.$confirm("确定要修改银行信息吗？", "修改银行信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.disabled = true;
        this.enterpriseForm.amount = "";
        this.enterpriseForm.smsCode = "";
      });
    },

    // 下一步
    submitUpload(formRefName) {
      // 企业实名先进行对公打款
      if (this.pageIndex == 2 && !!this.disabled) {
        return false;
      }

      this.$refs[formRefName].validate(valid => {
        if (valid) {
          // 验证金额验证码参数
          let params =
            this.pageIndex == 2
              ? {
                  amount: this.enterpriseForm.amount,
                  smsCode: this.enterpriseForm.smsCode
                }
              : this.thatPersonForm;
          this.$http[
            this.pageIndex == 1
              ? "postUpdateContractOperatorInfo"
              : "postVerifyPaymentAndSmsCode"
          ](params).then(res => {
            if (res.statusCode === HTTP_CODE.suc) {
              // 是经办人下一步显示企业
              if (this.pageIndex == 1) {
                this.pageIndex = 2;
                // 清除表单校验
                this.$nextTick(() => {
                  this.$refs.enterpriseFormRef.clearValidate();
                });
              } else {
                // 跳转首页签署合同
                this.$router.push({
                  path: "/indexMer"
                });
                setLocal("routerIndexMer", true);
              }
              // "600500", "小额打款验证过期" 需要重新验证打款
            } else if (
              this.pageIndex == 2 &&
              res.statusCode === HTTP_CODE.expire
            ) {
              this.disabled = true;
              (this.enterpriseForm.amount = ""),
                (this.enterpriseForm.smsCode = "");
            }
          });
        }
      });
    }
  }
};
</script>

<style>
#onlineContractSign .el-form-item {
  margin-bottom: 16px;
}

#onlineContractSign .el-form-item__content {
  text-align: left;
}

#onlineContractSign .el-form-item__label {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #272727;
}

#onlineContractSign .el-input {
  width: 300px;
  color: #595959;
}

#onlineContractSign .el-input input {
  width: 300px;
  height: 40px;
  border-radius: 4px;
  color: #595959;
}
#onlineContractSign .el-input__inner::placeholder {
  font-size: 13px;
}

/* 考虑到兼容的话就是*/
/* 谷歌 */
#onlineContractSign .el-input__inner::-webkit-input-placeholder {
  font-size: 13px;
}
/* 火狐 */
#onlineContractSign .el-input__inner:-moz-placeholder {
  font-size: 13px;
}
/*ie*/
#onlineContractSign .el-input__inner:-ms-input-placeholder {
  font-size: 13px;
}
</style>

<style scoped lang="scss">
.page {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  .page-title {
    width: 100%;
    min-width: 1440px;
    height: 126px;
    background: linear-gradient(343deg, #f4f6fa 0%, #d9e2f3 100%), #ffffff;
    position: relative;
    .image-logo {
      width: 261px;
      height: 64px;
      position: absolute;
      top: 50%;
      left: 154px;
      transform: translate(0, -50%);
    }
    .image-bg {
      width: 626px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .information {
    width: 1136px;
    min-height: 600px;
    background: #fff;
    margin: 0 auto;
    margin-top: 24px;
    border-radius: 2px;
    padding: 51px 0 0;
    display: flex;
    justify-content: center;
    .content {
      .schedule {
        width: 493px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 34px;
        .one {
          display: flex;
          flex-direction: column;
          align-items: center;
          .ball {
            width: 39px;
            height: 39px;
            border-radius: 50%;
            text-align: center;
            line-height: 39px;
          }
          .blueBall {
            background: #1985ff;
            color: #fff;
          }
          .whiteBall {
            border: 1px solid #1985ff;
            color: #1985ff;
          }
          .character {
            margin-top: 7px;
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
            color: #595959;
          }
        }
        .line {
          width: 116px;
          height: 1px;
          margin-bottom: 26px;
          border: 1px dashed #1985ff;
        }
      }
      .tipsOne {
        width: 352px;
        height: 48px;
        margin-left: 81px;
      }
      .tipsTow {
        width: 419px;
        height: 69px;
        margin: 0 auto;
      }
      .tips {
        background: rgba(25, 133, 255, 0.08);
        border-radius: 2px;
        border: 1px solid #1985ff;
        display: flex;
        margin-bottom: 34px;
        .icon-tips {
          width: 50px;
          height: 100%;
          img {
            display: block;
            width: 16px;
            height: 16px;
            margin: 17px 16px 0;
          }
        }
        .text {
          margin-top: 14px;
          font-family: PingFangSC, PingFang SC;
          font-size: 14px;
          color: #272727;
        }
        .text-box {
          margin: 14px 0;
          font-family: PingFangSC, PingFang SC;
          font-size: 14px;
          color: #272727;
          margin-right: 28px;
          .btn {
            font-size: 14px !important;
            position: relative;
            margin-left: 13px;
            &::before {
              content: "";
              width: 11px;
              height: 14px;
              left: -15px;
              top: 3px;
              background: url("../../../static/onLineContractSign/icon_Shape.png")
                no-repeat;
              background-size: cover;
              position: absolute;
            }
          }
        }
      }
    }
  }
}

.margin16 {
  margin-right: 16px;
}

.btnLargeFullColor {
  margin-top: 8px;
}
.greyColor {
  padding-left: 15px;
  color: #595959;
}
.form_money {
  position: relative;
  .moneyBtn {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .sureBtn {
    color: #1985ff;
    position: absolute;
    right: -70px;
    top: 50%;
    transform: translate(0, -50%);
  }
}
.btnLineColorDisabled {
  color: #fff;
  background: rgba(25, 133, 255, 0.4);
  box-shadow: 0rpx -2rpx 4rpx 0rpx rgba(0, 0, 0, 0.06);
  border: 1px solid #bfddff;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineContractSign/fillInInformation.vue